export default "__VITE_ASSET__CS6kGoBy__"